export interface FooterHelpLink {
  title: string;
  url: string;
}

export interface StaticFooterData {
  helpLinks: FooterHelpLink[];
}

const footerData: Record<string, StaticFooterData> = {
  'en-US': {
    helpLinks: [
      {
        title: 'HELP CENTER',
        url: 'https://support.laligagolazos.com/hc/en-us',
      },
      {
        title: 'Creating a Dapper Account',
        url: 'https://support.laligagolazos.com/hc/en-us/articles/9982860879379-Creating-a-LaLiga-Golazos-Account',
      },
    ],
  },
  es: {
    helpLinks: [
      {
        title: 'CENTRO DE AYUDA',
        url: 'https://support.laligagolazos.com/hc/es-es',
      },
      {
        title: '¿Cómo Crear una Dapper Wallet?',
        url: 'https://support.laligagolazos.com/hc/es-es/articles/9981339857811--C%C3%B3mo-Crear-una-Dapper-Wallet-',
      },
      {
        title: 'Únete a nuestro Discord',
        url: 'https://support.laligagolazos.com/hc/es-es/articles/9981204536467-%C3%9Anete-a-nuestro-Discord',
      },
    ],
  },
};

export const getStaticFooterData = (locale: string): StaticFooterData => {
  return footerData[locale] || footerData['en-US'];
};
